import React, { useEffect, useState } from 'react';
import { DashboardSection } from '../../../../../constants/newDashboards';
import { DashboardPanel } from '../../dashboardPanel/dashboardPanel';
import { Section } from '../../../v1/Section/Section';
import StatsPanel from '../../statsPanel/statsPanel';
import { FunnelPanel } from '../../funnelPanel/funnelPanel';

const DashboardPageSection = ({ section }: { section: DashboardSection }) => {
  const [hasStats, setHasStats] = useState(false);

  useEffect(() => {
    setHasStats(!!section.statsPanel);
  }, []);
  const [multiPanelIndex, setMultiPanelIndex] = useState(0);
  return (
    <Section
      title={section.title}
      isNew={section.new}
      isBeta={section.beta}
      stats={hasStats ? <StatsPanel definition={section.statsPanel} /> : undefined}
    >
      {section.panels.map(panelDefinition => {
        if (panelDefinition.isFunnel) {
          return <FunnelPanel panelDefinition={panelDefinition} />;
        } else {
          return (
            <DashboardPanel
              key={panelDefinition.title}
              panelDefinition={panelDefinition}
              hasPriority={
                panelDefinition.type === 'MultiPanel' &&
                panelDefinition.panels[0].type === 'BarChartPanel'
              }
              parentMultiPanelIndex={multiPanelIndex}
              setParentMultiPanelIndex={setMultiPanelIndex}
            />
          );
        }
      })}
    </Section>
  );
};

export default DashboardPageSection;
